import { gaNavigateTo } from '../requestedDocuments/ga';
import {
  DOC_TYPE_DOCUMENT,
  DOC_TYPE_FORM,
  DOC_TYPE_ID_CHECK,
  DOC_TYPE_IMMEDIATE_CONFIRMATION,
  DOC_TYPE_INFORMATION,
  DOC_TYPE_PAYMENT,
  DOC_TYPE_PDF_FORM
} from './utils';

export const PATHS = {
  SCAN_QR: 'ScanQR',
  SIGN_NOW: 'SignNow',
  FILE_DOWNLOAD: 'FileDownload',
  IMAGE_VIEWER: 'ImageViewer',
  PAYMENT: 'Payment',
  VIEWER: 'Viewer',
  PDF_FORM: 'PDFForm',
  ID_CHECK: 'IDCheck',
  QUICK_FORM: 'Form',
  IMAGE_FILTER: 'Filter',
  THANKYOU: 'Thankyou',
  GALLERY: 'Gallery',
  HOME: 'Home',
  LOAD: 'Load',
  LIST: 'List',
  IMAGE_CROPPER: 'Crop'
};

let f7routerInstance;
export const initF7Navigator = (f7router, reInit) => {
  if (!f7routerInstance || reInit) {
    f7routerInstance = f7router;
  }
};

const baseNavigate = (page, props = {}, navProps = {}, force) => {
  gaNavigateTo(page);

  f7routerInstance.navigate(
    `/${page +
      (props && props.documentPageId ? '/' + props.documentPageId : '')}`,
    {
      ...navProps,
      props: props,
      ...(force && { force: true, clearPreviousHistory: true })
    }
  );
};

const navigateWithDocument = (page, docId, props, navProps) => {
  if (navProps && navProps.back) {
    baseNavigate(
      page,
      {
        requestedDocumentId: docId,
        documentPageId: docId,
        forceBackwardAnimation: true,
        ...props
      },
      {
        ...navProps,
        animate: false
      }
    );
  } else {
    baseNavigate(
      page,
      {
        requestedDocumentId: docId,
        documentPageId: docId,
        ...props
      },
      navProps
    );
  }
};

const baseBackTo = (path, props = {}, navProps = {}) => {
  gaNavigateTo(path);
  f7routerInstance.back(`/${path}`, {
    ...navProps,
    props: props
  });
};

const forceBackTo = (path, props, animate) =>
  baseBackTo(path, props, {
    ...(animate !== undefined && { animate }),
    force: true,
    clearPreviousHistory: true
  });

const forceNavigateTo = (path, props, animate) =>
  baseNavigate(
    path,
    props,
    {
      ...(animate !== undefined && { animate })
    },
    true
  );

export const f7navigator = {
  forceNavigateTo: (docId, props, navProps) =>
    forceNavigateTo(docId, props, navProps),
  toLoadRequestFromQR: requestInfo =>
    baseNavigate(
      PATHS.LOAD,
      {
        requestInfo,
        startedFromQR: true
      },
      {
        force: true,
        clearPreviousHistory: true
      }
    ),
  backToDocumentByPath: (path, docId, props, navProps) => {
    navigateWithDocument(path, docId, props, { ...navProps, back: true });
  },
  toDocumentByPath: (path, docId, props, navProps) => {
    navigateWithDocument(path, docId, props, navProps);
  },
  backToDocument: (docType, docId, props, navProps) => {
    f7navigator.toDocument(docType, docId, props, { ...navProps, back: true });
  },
  toDocument: (docType, ...rest) => {
    switch (docType) {
      case DOC_TYPE_INFORMATION:
        f7navigator.toViewer(...rest);
        break;
      case DOC_TYPE_DOCUMENT:
        f7navigator.toGallery(...rest);
        break;
      case DOC_TYPE_IMMEDIATE_CONFIRMATION:
        f7navigator.toViewer(...rest);
        break;
      case DOC_TYPE_ID_CHECK:
        f7navigator.toIdCheck(...rest);
        break;
      case DOC_TYPE_FORM:
        f7navigator.toQuickForm(...rest);
        break;
      case DOC_TYPE_PDF_FORM:
        f7navigator.toPDFForm(...rest);
        break;
      case DOC_TYPE_PAYMENT:
        f7navigator.toPayment(...rest);
        break;
      //no default
    }
  },
  toPDFForm: (docId, props, navProps) =>
    navigateWithDocument(PATHS.PDF_FORM, docId, props, navProps),
  toQuickForm: (docId, props, navProps) =>
    navigateWithDocument(PATHS.QUICK_FORM, docId, props, navProps),
  toViewer: (docId, props, navProps) =>
    navigateWithDocument(PATHS.VIEWER, docId, props, navProps),
  toIdCheck: (docId, props, navProps) =>
    navigateWithDocument(PATHS.ID_CHECK, docId, props, navProps),
  toGallery: (docId, props, navProps) =>
    navigateWithDocument(PATHS.GALLERY, docId, props, navProps),
  toImageCropper: (docId, props, navProps) =>
    navigateWithDocument(PATHS.IMAGE_CROPPER, docId, props, navProps),
  toPayment: (docId, props, navProps) =>
    navigateWithDocument(PATHS.PAYMENT, docId, props, navProps),
  toImageViewer: (docId, props, navProps) =>
    navigateWithDocument(PATHS.IMAGE_VIEWER, docId, props, navProps),
  toImageFilter: (docId, props, navProps) =>
    navigateWithDocument(PATHS.IMAGE_FILTER, docId, props, navProps),
  toThankYou: (props, navProps) =>
    baseNavigate(PATHS.THANKYOU, props, navProps),
  toList: (props, navProps, force) =>
    baseNavigate(PATHS.LIST, props, navProps, force),
  toHome: (props, navProps) => baseNavigate(PATHS.HOME, props, navProps),
  toPath: (path, props, navProps) => baseNavigate(path, props, navProps),
  toScanQR: (props, navProps) => forceBackTo(PATHS.SCAN_QR, props, navProps),
  forceBackTo: (path, props, animate) => forceBackTo(path, props, animate),
  forceBackToList: (props, animate) => forceBackTo(PATHS.LIST, props, animate),
  forceBackToThankyou: (props, animate) => {
    if (window.isDesktop) {
      f7navigator.forceBackToList({
        showThankyouPopUp: true
      });
    } else forceBackTo(PATHS.THANKYOU, props, animate);
  },
  forceBackToHome: (props, animate) => forceBackTo(PATHS.HOME, props, animate),
  forceBackToDocumentPage: (path, docId, props, animate) =>
    forceBackTo(
      path,
      {
        ...props,
        requestedDocumentId: docId
      },
      animate
    )
};
